module.exports = __webpack_public_path__ + "img/store-sport-zone.3f921530.jpg";